const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5D7E5"
    },
    d: "M350.608,109.612l-0.475,0.219L189.848,45.717c-1.972-0.792-4.059-1.182-6.145-1.189v401.993 l160.709,64.278c0.204,0.081,0.424,0.048,0.629,0.121c1.805,0.642,3.667,1.074,5.566,1.074V109.612H350.608z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE2EF"
    },
    d: "M183.703,44.528c-2.121-0.007-4.241,0.383-6.246,1.189L10.501,112.499 c-6.348,2.533-10.499,8.674-10.499,15.5V495.3c0,5.538,2.75,10.717,7.337,13.826c4.587,3.103,10.412,3.744,15.555,1.674 l160.76-64.299l0.05,0.02V44.528H183.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE2EF"
    },
    d: "M504.302,47.151c-4.794-3.06-10.826-3.473-16-1.092l-137.695,63.552v402.384 c1.459,0,2.909-0.26,4.336-0.646c0.416-0.112,0.81-0.263,1.217-0.407c0.481-0.17,0.979-0.269,1.447-0.485l144.694-66.782 c5.914-2.728,9.696-8.647,9.696-15.157V61.217C511.998,55.521,509.096,50.222,504.302,47.151z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95D6A6"
    },
    points: "168.477,85.271 33.393,139.303 33.393,470.637 183.653,410.54 183.653,85.271 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#34B772"
    },
    points: "356.173,143.82 351.075,146.173 198.829,85.271 183.653,85.271 183.653,410.54  350.14,477.126 356.173,474.342 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5F4A"
    },
    d: "M183.707,0C93.929,0,37.764,97.644,82.475,175.233c0.011,0,0.011,0.006,0.011,0.006l86.773,150.324 c6.4,11.111,22.5,11.111,28.899,0l86.784-150.33C329.599,97.734,273.57,0,183.707,0z M183.653,166.955 c-27.619,0-50.087-22.468-50.087-50.087s22.468-50.087,50.087-50.087s50.087,22.468,50.087,50.087S211.272,166.955,183.653,166.955z "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95D6A6"
    },
    points: "350.608,477.774 478.607,417.833 478.607,87.309 356.173,143.82 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8482B"
    },
    d: "M183.707,0c-0.019,0-0.036,0.004-0.055,0.004v66.778c27.619,0,50.087,22.468,50.087,50.087 s-22.468,50.087-50.087,50.087v166.934c5.644,0.018,11.295-2.753,14.505-8.327l86.784-150.33C329.599,97.734,273.57,0,183.707,0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.bfd609905879ccb2702830469f9d2103.svg";
export { ForwardRef as ReactComponent };